// Soft pastel gradient blur used behind the contact and 404 heroes - recreates
// the `imgBlur` PNG from the Figma frames without shipping the 700KB image.
// Pointer-events disabled and aria-hidden so it's purely decorative.

type GlowBackdropProps = {
  className?: string;
};

export function GlowBackdrop({ className = "" }: GlowBackdropProps) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      <div className="absolute -left-32 top-0 size-[480px] rounded-full bg-brand-tint/60 blur-3xl" />
      <div className="absolute -right-32 top-1/3 size-[420px] rounded-full bg-rose-200/60 blur-3xl" />
      <div className="absolute bottom-0 left-1/3 size-[360px] rounded-full bg-accent-purple/15 blur-3xl" />
    </div>
  );
}
